import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import './Bullet.scss';

const Bullet = ({ icon, children }) => (
    <div className="list-item">
        <FontAwesome className="primary-yellow con md image_center icon075" name={icon} />
        <span className="list-text">{children}</span>
    </div>
);

Bullet.propTypes = {
    icon: PropTypes.string
};

Bullet.defaultProps = {
    icon: 'dot'
};

export default Bullet;



// WEBPACK FOOTER //
// ./src/components/Bullet/Bullet.jsx